<template>
    <el-dialog
            :title="dialogTitle"
            :visible.sync="isModalVisible"
            width="500px">

        <div class="row">
            <status-message v-model="statusMessage"></status-message>
        </div>
        <el-form label-width="120px">
            <el-form-item label="Sales Rep" v-show="!isInEditMode">
                <el-select v-model="assign.salesmanId" placeholder="Sales rep">
                    <el-option
                            v-for="(value, key) in salesmenList"
                            :key="key"
                            :label="value"
                            :value="key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="From">
                <el-date-picker
                        v-model="assign.from"
                        type="month"
                        value-format="yyyy-MM-dd"
                        placeholder="From">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="To">
                <el-date-picker
                        v-model="assign.to"
                        type="month"
                        value-format="yyyy-MM-dd"
                        placeholder="To">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="Type" v-show="!isInEditMode">
                <el-select v-model="assign.type" placeholder="Type">
                    <el-option label="Reassign - remove other assignments" value="reassign" key="reassign"></el-option>
                    <el-option label="Coassign - keep other assignments" value="coassign" key="coassign"></el-option>
                </el-select>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="onUpdateAssign">{{isInEditMode ? 'Save' : 'Assign'}}</el-button>
              </span>
    </el-dialog>
</template>

<script>
    export default {
        name: 'assign-salesman-modal',
        props: {
            visible: Boolean,
            salesmenList: Object,
            value: Object
        },
        data() {
            return {
                assign: {
                    from: moment().format('YYYY-MM-DD'),
                    to: moment().add(10, "years").format('YYYY-MM-DD'),
                    type: null,
                    salesmanId: null
                },
                isModalVisible: this.visible
            };
        },
        computed: {
            isInEditMode(){
                return this.value != null;
            },
            dialogTitle(){
                return this.isInEditMode ? 'Sales rep' : 'Assign a sales rep';
            }
        },
        methods: {
            validate(){
                let errorMessage = '';
                if(!this.isInEditMode && !this.assign.salesmanId){
                    errorMessage += "Please select salesman. <br/>";
                }
                if(this.assign.to < this.assign.from){
                    errorMessage += "To cannot be before from. <br/>";
                }
                if(!this.isInEditMode && !this.assign.type){
                    errorMessage += "Please select type. <br/>";
                }

                return errorMessage;
            },
            onUpdateAssign(){
                let errorMessages = this.validate();
                if(errorMessages){
                    this.showError(errorMessages);
                    return;
                }
                this.hideStatusMessages();
                if(this.isInEditMode){
                    this.$emit('update-assign', this.assign);
                }
                else{
                    this.$emit('create-assign', this.assign);
                }
                this.isModalVisible = false;
                this.$emit('input', null);
            },
            initialize(value){
                if(!value) {
                    let from = moment().subtract(1, 'quarter').startOf('quarter');
                    this.assign = {
                        from: from.format('YYYY-MM-DD'),
                        to: from.clone().add(1, "years").subtract(1, 'months').format('YYYY-MM-DD'),
                        type: null,
                        salesmanId: null
                    };
                    return;
                }
                this.assign = {
                    id: value.id,
                    from: value.from,
                    to: value.to,
                }
            },
        },
        watch: {
            visible(){
                this.isModalVisible = this.visible;
                if(this.visible){
                    this.initialize(this.value);
                    this.isModalVisible = this.visible;
                }
                else{
                    this.$emit('input', null);
                }

            },
            isModalVisible(){
                this.$emit('update:visible', this.isModalVisible);
            }
        }
    }
</script>
